module.exports = __webpack_public_path__ + "static/media/airtable-icon.72f20372.svg";